import * as React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Fab, Badge } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { getPilotCart, getPilotStore } from "../utils/pilotUtils";
import { motion, AnimatePresence } from "framer-motion";

function PilotCartFAB() {
  const navigate = useNavigate();
  const location = useLocation();
  const [cartCount, setCartCount] = useState(0);
  const [visible, setVisible] = useState(false);

  const fetchCartCount = async () => {
    try {
      const [cart, store] = await Promise.all([getPilotCart(), getPilotStore()]);
      const count = cart.totalCount || 0;
      // Hide FAB if not in store, on cart page, or empty cart
      setCartCount(count);
      setVisible(
        !!store &&
          count > 0 &&
          location.pathname !== "/pilot/cart"
      );
    } catch (error) {
      console.error("Error fetching cart count:", error);
      setVisible(false);
    }
  };

  useEffect(() => {
    fetchCartCount();
    // Refresh cart count every 2 seconds
    const interval = setInterval(fetchCartCount, 2000);
    return () => clearInterval(interval);
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0 }}
          transition={{ duration: 0.3 }}
          style={{
            position: "fixed",
            bottom: "9vh",
            right: "2vw",
            zIndex: 1000,
          }}
        >
          <Fab
            color="primary"
            onClick={() => navigate("/pilot/cart")}
            sx={{
              background: "linear-gradient(135deg, #a4243d 0%, #ff6b6b 100%)",
              color: "white",
              width: "64px",
              height: "64px",
              boxShadow: "0 4px 20px rgba(164, 36, 61, 0.4)",
              "&:hover": {
                background: "linear-gradient(135deg, #8a1e33 0%, #e55555 100%)",
                boxShadow: "0 6px 24px rgba(164, 36, 61, 0.5)",
                transform: "scale(1.05)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <Badge
              badgeContent={cartCount}
              color="error"
              sx={{
                "& .MuiBadge-badge": {
                  background: "#ffc107",
                  color: "#2d3436",
                  fontWeight: "700",
                  fontFamily: "RobotoSlab",
                },
              }}
            >
              <ShoppingCartIcon />
            </Badge>
          </Fab>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default PilotCartFAB;
